import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ContextMenuOptions} from '../../Models/contextMenu';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.css']
})
export class ContextMenuComponent implements OnInit{
  @Input() contextMenuOptions: ContextMenuOptions;
  @Output() onContextMenuItemClick: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
  }

  onContextMenuClick(event, data): any {
    data();
  }

  addClass(event): void {
    if (event.target.nodeName.toLowerCase() == "div") {
      event.target.className += ' context-menu-hover';
    }
  }

  removeClass(event): void {
    if (event.target.nodeName.toLowerCase() == "div") {
      event.target.className = event.target.className.replace('context-menu-hover', '');
    }
  }
}


